import { Checkbox, FormControlLabel } from '@mui/material';
import { CheckboxProps } from '@mui/material/Checkbox/Checkbox';
import FormControl from '@mui/material/FormControl';
import { Field, FieldProps } from 'formik';
import { memo } from 'react';

import { ResourceManagerRule } from '../../../../backend';

export const ActivatedField = memo((props: CheckboxProps) => {
    return (
        <Field name="activated">
            {({ field }: FieldProps<boolean, ResourceManagerRule>) => (
                <FormControl>
                    <FormControlLabel
                        control={<Checkbox checked={field.value} {...field} {...props} />}
                        label="Rule Activated"
                    />
                </FormControl>
            )}
        </Field>
    );
});
